import { getProductId } from './userEvents';

const pickDefined = (...values) => {
  for (let i = 0; i < values.length; i += 1) {
    const value = values[i];
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }
  return null;
};

const extractPriceText = (value) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  if (typeof value === 'object') {
    return pickDefined(value['#text'], value['@text'], value.text, value[0]);
  }
  return String(value);
};

const inferSpiderName = (productId) => {
  const id = String(productId || '').toLowerCase();
  if (id.startsWith('amz-')) return 'amazon';
  if (id.startsWith('imp-wmt-') || id.startsWith('wmt-')) return 'walmart';
  if (id.startsWith('rakuten-')) return 'rakuten';
  return 'unknown';
};

export const normalizeSingleProduct = (product) => {
  if (!product || typeof product !== 'object' || Array.isArray(product)) {
    return null;
  }

  const productId = getProductId(product);
  const productname = pickDefined(product.productname, product.productName, product.name) || '';
  const linkurl = pickDefined(product.linkurl, product.linkURL, product.url);
  const imageurl = pickDefined(product.imageurl, product.imageURL, product.image);

  const priceText = extractPriceText(
    pickDefined(product.saleprice, product.price, product.actualPrice)
  );
  const price = product.price && typeof product.price === 'object'
    ? product.price
    : {
        '@currency': 'USD',
        '#text': priceText || '0',
      };

  let descriptionLong = null;
  let descriptionShort = null;
  if (product.description && typeof product.description === 'object') {
    descriptionLong = pickDefined(product.description.long, product.description.short);
    descriptionShort = pickDefined(product.description.short, product.description.long);
  } else if (typeof product.description === 'string') {
    descriptionLong = product.description;
    descriptionShort = product.description;
  }
  if (!descriptionLong && !descriptionShort) {
    descriptionLong = productname;
    descriptionShort = productname;
  }

  const run = product.run && typeof product.run === 'object'
    ? product.run
    : { spider_name: inferSpiderName(productId) };

  return {
    ...product,
    productId: productId ? String(productId) : product.productId,
    productname,
    linkurl,
    imageurl,
    price,
    description: {
      long: descriptionLong || '',
      short: descriptionShort || '',
    },
    run,
  };
};

const isValidProduct = (product) => {
  return product
    && typeof product === 'object'
    && !Array.isArray(product)
    && product !== '[object Object]';
};

export const resolveSingleProduct = (route, store) => {
  const fromStore = store?.state?.single_product;
  if (isValidProduct(fromStore)) {
    return fromStore;
  }

  const fromQuery = route?.query?.singleproduct;
  if (!isValidProduct(fromQuery)) {
    return null;
  }

  if (typeof fromQuery === 'string' && fromQuery === '[object Object]') {
    return null;
  }

  return fromQuery;
};

export const navigateToSingleProduct = (router, store, product, extraQuery = {}) => {
  const normalized = normalizeSingleProduct(product);
  if (!normalized) {
    return;
  }

  store.state.single_product = normalized;

  const id = Math.random().toString(36).slice(2);
  router.push({
    path: `/single-product/product/${id}`,
    query: extraQuery,
  });
};

export const getProductDescription = (product) => {
  if (!product || !product.description) {
    return '';
  }
  return product.description.long || product.description.short || '';
};
